import React, { createContext, useState, useEffect, useContext } from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { amber, grey, deepOrange, blue, blueGrey } from '@mui/material/colors';
import useMediaQuery from '@mui/material/useMediaQuery';
import { CssBaseline } from '@mui/material';
//import { themeState } from './themeState';
//import { useRecoilState } from 'recoil';
import { ThemeContext } from '../App';

const CustomTheme = props => {
	const { children } = props;
    //const [currentTheme, setCurrentTheme] = useRecoilState(themeState);
    const [theme, setCurrentTheme] = useContext(ThemeContext);

    const getTheme = (themeName) => ({
        typography: {
            "fontFamily": `"Open Sans", "Helvetica", "Arial", sans-serif`,
            "fontSize": 14,
            "fontWeightLight": 300,
            "fontWeightRegular": 400,
            "fontWeightMedium": 500
           },
        palette: {
            mode : (themeName === 'dark' ? 'dark' : 'light'),
          ...(themeName === 'dark'
            ? {
                // palette values for dark mode
                primary: {
                    main: '#007FFF',
                    dark: '#282c34',
                },
                secondary: {
                    main: '#f50057',
                },
                text: {
                    primary: grey[200],
                    secondary: grey[600],
                    header: '#F2D349'
                },
                background: {
                    default: '#001E3C',
                    paper: '#132F4C',
                },
                toolbar:
                {
                    background: '#00152b',
                },
                logo: '#ffffff'
              }
            : {
                // palette values for light mode
                primary: {
                    main: '#00458B',
                  },
                divider: amber[200],
                text: {
                  primary: grey[900],
                  secondary: grey[800],
                  header: '#1D2228'
                },
                background:{
                    default:'#fefefe',
                    paper: '#f5f5f5',
                    appbar: '#ffffff'
                },
                toolbar:
                {
                    background: blueGrey[100],
                },
                logo: '#1D2228'
            }),
        },
      });

    const isDarkThemeBrowserPreference = useMediaQuery('(prefers-color-scheme: dark)');
    const initialTheme = (isDarkThemeBrowserPreference ? 'dark' : 'light');


    // useEffect(() => {
    //     if(initial) setThemeName(initialTheme);
    // },[initialTheme]);

	// Get current theme from localStorage, if not saved then use browser preference
	//const currentTheme = localStorage.getItem('appTheme') || initialTheme;

	// State to hold selected theme
	//const [ themeName, _setThemeName ] = useState(currentTheme);
    //const [ initial, setInitial ] = useState(localStorage.getItem('appTheme') === null);

	// Retrieve theme object by theme name
    const currentTheme = React.useMemo(() =>
          createTheme(getTheme(theme)),
        [theme],
    );

    


	// Wrap _setThemeName to store new theme names in localStorage
	// const setThemeName = name => {
	// 	localStorage.setItem('appTheme', name);
	// 	_setThemeName(name);
	// };


    //console.log('theme name:', theme, JSON.parse(JSON.stringify(currentTheme)), JSON.parse(JSON.stringify(theme)));

	return (
        <ThemeProvider theme={currentTheme}>
        <CssBaseline/>
            {children}
        </ThemeProvider>
	);
};

export default CustomTheme;